import SlotPicker from './SlotPicker'

interface Props {
  /** Legacy prop — accepted for backward compatibility with callers that still
   *  pass `calLink`. Ignored: Cal.com was decommissioned in Phase 25 (2026-05-12). */
  calLink?: string
  eventTypeSlug?: string
}

export default function BookingPicker({ eventTypeSlug }: Props) {
  return <SlotPicker eventTypeSlug={eventTypeSlug ?? ''} />
}
